import { configureDevStore } from 'helpers/config-store-dev';
import { configureProdStore } from 'helpers/config-store-prod';

export default process.env.NODE_ENV === 'production'
  ? configureProdStore
  : configureDevStore;
